import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";
import { urlSynchronizeViewersSecured, urlViewerSecured } from "../../api/urls";

const generateFilterQuery = (filters) => {
  const sort = filters.sort;
  let filter = "?";
  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

export const synchronizeData = createAction("SYNCHRONIZE_DATA", (obj, param) =>
  apiPut(urlSynchronizeViewersSecured, obj, param, true)()
);

export const getAll = createAction("GET_PERSONS", (filter, param) =>
  apiGet(urlViewerSecured + generateFilterQuery(filter), param, false)()
);

export const createViewer = createAction("CREATE_VIEWER", (obj,param) =>
  apiPost(urlViewerSecured, obj, param, true)()
);
